import { ActivityIndicator, Platform, type ColorValue, type ViewStyle } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Constants from 'src/core/utils/Constants';

interface LoadingIndicatorProps {
	size?: number | 'small' | 'large';
	style?: ViewStyle;
	color?: ColorValue;
}

function LoadingIndicator({
	style,
	size = Platform.OS === Constants.platformIos ? 'small' : 'large',
	color = Colors.green,
}: LoadingIndicatorProps) {
	return <ActivityIndicator color={color} size={size} style={style} />;
}

export default LoadingIndicator;
